import {isEqual} from 'lodash';
import {emptyArray} from '@packages/utilities/fp/utils';
import {Expressions} from '@packages/systems/wfdl';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import type {TranslatedNodeData} from '@packages/systems/localization-types';
import {getPathsForElement} from './getPathsForElement';
import {reservedImageAltValues, ALT_PATH} from './constants';

export function getTranslatableAttributesForElement(
  element: ExpressionElement,
  parentElement: ExpressionElement
): TranslatedNodeData[] {
  const paths = getPathsForElement(element);

  if (paths === emptyArray) {
    return emptyArray;
  }

  return paths.reduce<TranslatedNodeData[]>((attributesToTranslate, path) => {
    const value = Expressions.getElementDataAt(element, path, 'Text', null);

    if (!value) {
      return attributesToTranslate;
    }

    // If the path is for the 'alt' attribute and the value is reserved skip.
    if (isEqual(path, ALT_PATH) && reservedImageAltValues.includes(value)) {
      return attributesToTranslate;
    }

    attributesToTranslate.push({
      _id: Expressions.getElementId(element),
      type: 'element-attribute',
      text: true,
      v: value,
      path,
      translatableParentId: Expressions.getElementId(parentElement),
    });

    return attributesToTranslate;
  }, []);
}
